import React, { useState } from 'react';
import { FaChartBar, FaTable } from 'react-icons/fa';

import { CardWidget } from './styles';
import TabelaDados, { TabelaDadosProps } from './TabelaDados';
import Button from '../Button';

interface WidgetCardProps {
  titulo: string;
  children: React.ReactNode;
  /** quando presente, mostra o botão de alternar gráfico/tabela */
  tabela?: TabelaDadosProps;
  larguraTotal?: boolean;
}

// Moldura de todo widget de gráfico: título + alternância para a visão em tabela
export default function WidgetCard({ titulo, children, tabela, larguraTotal }: WidgetCardProps) {
  const [verTabela, setVerTabela] = useState(false);

  return (
    <CardWidget $larguraTotal={larguraTotal}>
      <header>
        <h3>{titulo}</h3>
        {tabela && (
          <Button
            variante='fantasma'
            tamanho='sm'
            icone={verTabela ? <FaChartBar /> : <FaTable />}
            onClick={() => setVerTabela(!verTabela)}
            title={verTabela ? 'Ver gráfico' : 'Ver tabela'}
            aria-label={verTabela ? 'Ver gráfico' : 'Ver tabela'}
          />
        )}
      </header>
      {verTabela && tabela ? <TabelaDados {...tabela} /> : children}
    </CardWidget>
  );
}
